<template>
  <div v-loading="isRedirecting" class="paper-analysis-redirect">
    <div class="redirect-tip">正在打开论文分析...</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "FullTxtArtAnalysis",
  props: {
    greetingMsg: {},
    curInfoToolTipMsg: {
      type: String,
    },
    dataContent: {
      type: [Array, Object],
    },
    conversationId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isRedirecting: false,
    };
  },
  mounted() {
    this.openLiteratureAnalysis();
  },
  watch: {
    dataContent(newVal) {
      if (newVal != null) {
        this.openLiteratureAnalysis();
      }
    },
  },
  methods: {
    openLiteratureAnalysis() {
      this.isRedirecting = true;
      if (window) {
        history.pushState(null, "", "/asp/literature_analysis");
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
      }
      this.$nextTick(() => {
        this.isRedirecting = false;
      });
    },
    close_tool() {
      this.$emit("close_tool");
    },
    full_txt_art_analysis(data_ruid, file_name, is_create_task) {
      this.openLiteratureAnalysis();
    },
    handleUploadSuccess(res, files) {
      if (res.code == -1) {
        this.$message.warning(res.msg);
        return;
      }

      this.full_txt_art_analysis(res.data, files.name, true);
    },
  },
};
</script>

<style scoped>
.paper-analysis-redirect {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redirect-tip {
  color: var(--txt-color2);
  font-size: 14px;
}
</style>
